/* eslint-disable import/prefer-default-export */

/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

export * from 'SourceComponent/ProductGallery/ProductGallery.config';
export const SLIDER_OVERLAY_WHEEL_STEP = 100;
export const SLIDER_WHEEL_STEP = 5;
export const AMOUNT_OF_PLACEHOLDERS = 4;
export const SLIDER_HEIGHT = 87;
export const NAV_BAR_HEIGHT = 60;
export const BREADCRUMBS_BOTTOM = 80;
